import React from "react"
import styled from "@emotion/styled"

const Contentwrap = styled.section`
    width: 96vw;
    margin: 0 auto;
    padding: 22.5vh 0;
    position: relative;
    box-sizing: border-box;
    scroll-snap-align: start;
    min-height: 100vh;
    @media (max-width: 599px) {
        padding: 20vh 0;
    }
`

const Content = ({ children, iD }) => {
    return (
        <Contentwrap id={iD}>
            {children}
        </Contentwrap>
    )
}

export default Content